import * as React from 'react';

import { Anchor } from '@packages/ui';

export interface LinkItemForFooterProps {
  title?: string;
  target?: string;
  externalLink?: boolean;
  href?: string | Record<string, unknown>;
  id?: string;
  className?: string;
}

export const LinkItemForFooter: React.FC<LinkItemForFooterProps> = React.memo(
  ({ children, className, title, target, href }) => {
    const anchorParams = typeof href === 'string' ? { href } : {};

    // TODO: use next-link for internal links
    return (
      <Anchor data-bi-id="footer-nav" target={target} title={title} className={className} {...anchorParams}>
        {children}
      </Anchor>
    );
  },
);
